import PropTypes from "prop-types";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

export const IconWithText = ({
  iconName = "20-add-sm",
  iconSize = 20,
  label = "",
}) => (
  <div className="text-darkest flex justify-center gap-1">
    <Icon type={iconName} size={iconSize} />
    <Typography.LabelSm weight="medium">
      <span className="text-darkest">{label}</span>
    </Typography.LabelSm>
  </div>
);

IconWithText.propTypes = {
  iconName: PropTypes.string,
  label: PropTypes.string,
  iconSize: PropTypes.number,
};
